/**
 * Number of active facet values across every filter attribute (the Advanced Filters button's
 * count badge, TEC navbar redesign Phase 1): sums the length of every attribute's value array in
 * the filters object, including `exclude_*`/`only_*` attributes (a real, results-changing
 * filter) and `firstSeenMin` (the posted-date filter). Sort is never part of this object (it's
 * tracked separately via useSearchSort), so it's never counted, matching the spec's "posted-date
 * counts, sort does not".
 */
export function countAppliedFilterValues(
  filtersObj: Record<string, string[] | undefined> | null | undefined,
  omit: readonly string[] = [],
): number {
  if (!filtersObj || typeof filtersObj !== 'object') return 0;
  let count = 0;
  for (const [attribute, values] of Object.entries(filtersObj)) {
    if (omit.includes(attribute)) continue;
    if (Array.isArray(values)) count += values.length;
  }
  return count;
}

/** Location attributes (both location systems, include and exclude). The Sage search bar's
 * filters chip leaves these out of its count because the Where chip beside it already shows
 * the applied place, so one Tampere filter isn't counted twice. */
export const LOCATION_FILTER_ATTRIBUTES = ['location', 'regionTags', 'exclude_location', 'exclude_regionTags'] as const;
